import { ExpressionValue } from "../../ExpressionValue";
import { BaseLogicExpression } from "../Logic/BaseLogic";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class StringListNotContainsExpression extends BaseLogicExpression {
    readonly __type: string = "String List Not Contains";
    readonly __ruleName: string = "Not Contains";
    value1: ExpressionValue;
    value2: ExpressionValue;

    constructor() {
        super();
        let dd = new StringDataDefinition();
        dd.list = true;

        this.value1 = ExpressionValue.createExpressionValue(this, "value1", dd);
        this.value2 = ExpressionValue.createExpressionValue(this, "value2", new StringDataDefinition());
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        let value2 = this.value2.evaluate(data, testContext);
        return !this.value1.evaluate(data, testContext).includes(value2);
    }
}
